import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';
import Stepper from 'react-stepper-horizontal';

import toast, { Toaster } from 'react-hot-toast';
import MyComponent from 'react-fullpage-custom-loader';
import APIURLs from './APIURLs';

import { NODE_APP_BASE_URL, REACT_APP_BASE_URL } from '../../constants/index';
import { changeColumnTitle } from 'services/MondayService';
import Select from 'react-select';
import { useHistory,useLocation} from 'react-router-dom';
import { decryptPlainText } from 'utils/tests';

const inputboxstyle = {
  borderRadius: '5px',
  height: '25px',
  width: '95%',
  backgroundColor: '#188754',
  color: '#A5E2C6',
  border: '1px solid white',
};

// const inputboxstyleGet = {
//     borderRadius: '5px',
//     height: '25px',
//     width: '92%',
//     backgroundColor: '#188754',
//     color: '#A5E2C6',
//     border: '1px solid white',
// };

const iconStyle = {
  display: 'inline-block',
  fontSize: '20px',
  color: 'white',
  cursor: 'help',
};

const PrevbuttonStyle = {
  borderRadius: '7px',
  width: '110px',
  height: '25px',
  backgroundColor: 'white',
  color: '#188754',
  display: 'inline',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  border: 'none',
  outline: 'none',
  marginTop: '10px',
  fontSize: '15px',
};

const NextbuttonStyle = {
  borderRadius: '7px',
  width: '110px',
  height: '25px',
  backgroundColor: 'white',
  color: '#188754',
  display: 'inline',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  border: 'none',
  outline: 'none',
  marginTop: '10px',
  fontSize: '15px',
};

const AddToListbuttonStyle = {
  borderRadius: '7px',
  width: '110px',
  height: '25px',
  backgroundColor: 'white',
  color: '#188754',
  display: 'inline',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  border: 'none',
  outline: 'none',
  fontSize: '15px',
};

const Step1Component = ({
  formData,
  handleChange,
  handleSubmit,
  isCheckedCreate,
  isCheckedUpdate,
  isCheckedComment,
  handleToggleCreate,
  handleToggleUpdate,
  handleToggleComment,
}) => {
  const switchStyles = {
    position: 'relative',
    display: 'inline-block',
    width: '35px',
    height: '12px',
    top: '2px',
  };

  const sliderStyles = {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isCheckedCreate ? '#2196f3' : '#188754',
    transition: '0.4s',
    borderRadius: '15px',
    border: '1px solid white',
  };

  const sliderStylesUpdate = {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isCheckedUpdate ? '#2196f3' : '#188754',
    transition: '0.4s',
    borderRadius: '15px',
    border: '1px solid white',
  };

  const sliderStylesComment = {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isCheckedComment ? '#2196f3' : '#188754',
    transition: '0.4s',
    borderRadius: '15px',
    border: '1px solid white',
  };

  const knobStyles = {
    position: 'absolute',
    content: '',
    height: '10px',
    width: '10px',
    left: isCheckedCreate ? '24px' : '1px',
    backgroundColor: 'white',
    transition: '0.4s',
    borderRadius: '100%',
  };

  const knobStylesUpdate = {
    position: 'absolute',
    content: '',
    height: '10px',
    width: '10px',
    left: isCheckedUpdate ? '24px' : '1px',
    backgroundColor: 'white',
    transition: '0.4s',
    borderRadius: '100%',
  };

  const knobStylesComment = {
    position: 'absolute',
    content: '',
    height: '10px',
    width: '10px',
    left: isCheckedComment ? '24px' : '1px',
    backgroundColor: 'white',
    transition: '0.4s',
    borderRadius: '100%',
  };

  return (
    <div
      className="justify-content-center align-items-center"
      style={{ marginLeft: '3%', fontSize: '14px' }}
    >
      <form onSubmit={handleSubmit}>
        <div style={{ fontSize: '16px' }}>
          <strong>We use cookies!</strong> Our ServiceNow Connector app uses
          cookies to ensure you get the best experience.{' '}
          <a
            href="https://www.appserve.ai/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', fontSize: '13px' }}
          >
            Privacy Policy
          </a>
          <br />
        </div>
        <br />
        <label>Enter ServiceNow Instance Name<span style={{color: 'red'}}>*</span></label>
        <input
          type="text"
          name="baseUrl"
          value={formData.baseUrl}
          onChange={handleChange}
          style={inputboxstyle}
          required
        />{' '}
        &nbsp;
        <span
          style={iconStyle}
          title="Enter Your ServiceNow Instance Name. URL not required. Ex. dev000000"
        >
          &#9432;
        </span>
        <br />
        <br />
        <label>Enter ServiceNow App Name<span style={{color: 'red'}}>*</span></label>
        <input
          type="text"
          name="snowAppName"
          value={formData.snowAppName}
          onChange={handleChange}
          style={inputboxstyle}
          required
        />{' '}
        &nbsp;
        <span style={iconStyle} title="Enter Your ServiceNow Application Name.">
          &#9432;
        </span>
        <br />
        <br />
        <label>Enter Client Id<span style={{color: 'red'}}>*</span></label>
        <input
          type="text"
          name="clientId"
          value={formData.clientId}
          onChange={handleChange}
          style={inputboxstyle}
          required
        />
        &nbsp;
        <span style={iconStyle} title="Enter Your ServiceNow Client ID">
          &#9432;
        </span>
        <br />
        <br />
        <label>Enter Client Secret<span style={{color: 'red'}}>*</span></label>
        <input
          type="text"
          name="clientSecret"
          value={formData.clientSecret}
          onChange={handleChange}
          style={inputboxstyle}
          required
        />
        &nbsp;
        <span style={iconStyle} title="Enter Your ServiceNow Client Secret.">
          &#9432;
        </span>
        <br />
        <br />
        {/* <label>Enter Monday Field Created In ServiceNow</label>
                <input type="text" name='mondayField' value={formData.mondayField} onChange={handleChange} style={inputboxstyle} />&nbsp;
                <span style={iconStyle} title="Enter Monday Integration Field Name ID in ServiceNow">
                    &#9432;
                </span> */}
        {/* <br /><br /> */}
        <label>Enter Monday Integration User ID</label>
        <input
          type="text"
          name="mondayIntgUserId"
          value={formData.mondayIntgUserId}
          onChange={handleChange}
          style={inputboxstyle}
        />
        &nbsp;
        <span style={iconStyle} title="Enter Monday Service Account User ID">
          &#9432;
        </span>
        <br />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '1px',
            marginTop: '10px',
          }}
        >
          <div style={{ flex: 1 }}>
            <label style={switchStyles}>
              <input
                type="checkbox"
                name="enableCreate"
                checked={isCheckedCreate}
                onChange={handleToggleCreate}
                style={{ display: 'none' }}
              />
              <span style={sliderStyles}>
                <span style={knobStyles}></span>
              </span>
            </label>{' '}
            <span style={{ fontSize: '10px' }}>Enable Create</span>
          </div>

          <div style={{ flex: 1 }}>
            <label style={switchStyles}>
              <input
                type="checkbox"
                name="enableUpdate"
                checked={isCheckedUpdate}
                onChange={handleToggleUpdate}
                style={{ display: 'none' }}
              />
              <span style={sliderStylesUpdate}>
                <span style={knobStylesUpdate}></span>
              </span>
            </label>{' '}
            <span style={{ fontSize: '10px' }}>Enable Update</span>
          </div>

          <div style={{ flex: 1 }}>
            <label style={switchStyles}>
              <input
                type="checkbox"
                name="enableComment"
                checked={isCheckedComment}
                onChange={handleToggleComment}
                style={{ display: 'none' }}
              />
              <span style={sliderStylesComment}>
                <span style={knobStylesComment}></span>
              </span>
            </label>{' '}
            <span style={{ fontSize: '10px' }}>Enable Comment</span>
          </div>
        </div>
        <br />
        <br />
      </form>
    </div>
  );
};

const Step2Component = ({
  formDataOfApiUrls,
  handleSnowTypeAndUrls,
  snowAPI,
  handleMenuOpen,
  optionsServiceNowTables,
  selectedValue,
  handleInputChange,
  handleScrollDown,
  handleScrollUp,
  loadOptions,
  loadDropdown
}) => {
  // const getApiUrls = APIURLs(formDataOfApiUrls.enable)
  return (
    <div
      className="justify-content-center align-items-center"
      style={{ marginLeft: '3%', fontSize: '12px' }}
    >
      <form>
        Select ServiceNow Entity
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '2px',
            marginBottom: '5px',
          }}
        >
          <Select
            cacheOptions
            defaultOptions
            isLoading={loadDropdown}
            isDisabled={loadDropdown}
            loadOptions={loadOptions}
            options={optionsServiceNowTables}
            placeholder="Choose a table..."
            onChange={handleSnowTypeAndUrls}
            value={selectedValue}
            onInputChange={handleInputChange}
            onMenuScrollToBottom={handleScrollDown}
            onMenuScrollToTop={handleScrollUp}
            onMenuOpen={handleMenuOpen}
            styles={{
              menu: (provided) => ({
                ...provided,
                width: '300px',     // constant width
              }),
              control: (provided) => ({
                ...provided,
                minWidth: '300px',  // input box also fixed
              }),
              option: (provided, state) => ({
                ...provided,
                color: 'black', // option text color
                backgroundColor: state.isFocused ? '#f0f0f0' : 'white', // hover effect
              }),
            }}
          />
          {/* <div style={{ flex: 0.2 }}>
            <input
              style={{}}
              type="radio"
              name="enable"
              value="incident"
              onChange={handleSnowTypeAndUrls}
              checked={formDataOfApiUrls.enable === 'incident' ? true : false}
            />
          </div> */}

          {/* <div style={{ flex: 0.8, display: 'inline', marginBottom: '6px' }}>
            <p style={{ display: 'inline' }}>Incident </p>
          </div>
          <div style={{ flex: 0.2 }}>
            <input
              style={{}}
              type="radio"
              name="enable"
              value="task"
              onChange={handleSnowTypeAndUrls}
              checked={formDataOfApiUrls.enable === 'task' ? true : false}
            />
          </div>

          <div style={{ flex: 0.8, display: 'inline', marginBottom: '6px' }}>
            <p style={{ display: 'inline' }}>Task </p>
          </div> */}

          {/* <div style={{ flex: 0.2 }}>
            <input
              hidden={true}
              style={{}}
              type="radio"
              name="enable"
              value="changeRequest"
              onChange={handleSnowTypeAndUrls}
              checked={
                formDataOfApiUrls.enable === 'changeRequest' ? true : false
              }
              disabled
            />
          </div> */}

          {/* <div style={{ flex: 0.8, display: 'inline', marginBottom: '6px' }}>
            <p hidden={true} style={{ display: 'inline' }}>
              Change Request{' '}
            </p>
          </div> */}

          {/* <div style={{ flex: 0.2 }}>
            <input
              hidden={true}
              style={{}}
              type="radio"
              name="enable"
              value="demand"
              onChange={handleSnowTypeAndUrls}
              checked={formDataOfApiUrls.enable === 'demand' ? true : false}
              disabled
            />
          </div> */}

          {/* <div style={{ flex: 0.8, display: 'inline', marginBottom: '6px' }}>
            <p hidden={true} style={{ display: 'inline' }}>
              Demand{' '}
            </p>
          </div> */}
        </div>
        <label>Get</label>
        <br />
        <input
          type="text"
          value={formDataOfApiUrls.value !== '' ? snowAPI.getUrl : null}
          style={inputboxstyle}
          disabled
        />
        &nbsp;
        <span style={iconStyle} title="Get the ServiceNow Information API URL">
          &#9432;
        </span>
        <br />
        <br />
        <label>Create</label>
        <br />
        <input
          type="text"
          value={formDataOfApiUrls.value !== '' ? snowAPI.createUrl : null}
          style={inputboxstyle}
          disabled
        />
        &nbsp;
        <span style={iconStyle} title="Create a ServiceNow Incident API URL">
          &#9432;
        </span>
        <br />
        <br />
        <label>Update</label>
        <br />
        <input
          type="text"
          value={formDataOfApiUrls.value !== '' ? snowAPI.updateUrl : null}
          style={inputboxstyle}
          disabled
        />
        &nbsp;
        <span style={iconStyle} title="Update a ServiceNow Incident API URL">
          &#9432;
        </span>
        <br />
        <br />
        <label>Get Fields</label>
        <br />
        <input
          type="text"
          value={formDataOfApiUrls.value !== '' ? snowAPI.getFieldsUrl : null}
          style={inputboxstyle}
          disabled
        />
        &nbsp;
        <span
          style={iconStyle}
          title="Get the ServiceNow Fields Information API URL"
        >
          &#9432;
        </span>
        <br />
        <br />
        <label>Add Attachments</label>
        <input
          type="text"
          value={formDataOfApiUrls.value !== '' ? snowAPI.attachmentUrl : null}
          style={inputboxstyle}
          disabled
        />
        &nbsp;
        <span
          style={iconStyle}
          title="Add the Attachment in ServiceNow API URL"
        >
          &#9432;
        </span> 
        <br />
        <br />
      </form>
    </div>
  );
};

const Step3Component = ({ fieldItemsList }) => {
  console.log('Fields Data ',fieldItemsList);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = fieldItemsList.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(fieldItemsList.length / itemsPerPage);
  // const [itemsList, setItemsList] = useState([]);
  // const options = [
  //     { value: 'Item 1', label: 'Item 1' },
  //     { value: 'Item 2', label: 'Item 2' },
  //     { value: 'Item 3', label: 'Item 3' },
  // ];

  // const handleChange = (selectedOption) => {
  //     const selectedItem = selectedOption.value;
  //     if (!itemsList.includes(selectedItem)) {
  //         setItemsList([...itemsList, selectedItem]);
  //     } else {
  //     }
  // };

  // const handleRemoveItem = (index) => {
  //     const newList = [...fieldItemsList];
  //     newList.splice(index, 1);
  //     setItemsList(newList);
  // };

  return (
    <div
      className="justify-content-center align-items-center"
      style={{ marginLeft: '3%', fontSize: '12px' }}
    >
      <div>
        {/* <Select
                    options={options}
                    onChange={handleFieldItemsChange}
                    placeholder="Select Fields"
                    isSearchable={true}
                    // onFocus={handleOnFocus}
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            backgroundColor: '#f0f0f0',
                            height: '0px',
                        }),
                        menu: (provided) => ({
                            ...provided,
                            backgroundColor: '#ffffff',
                            color: "black"
                        }),
                    }}
                /> */}
        <ul style={{ marginTop: '20px' }}>
          {currentItems.map((item, index) => (
            <li
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '5px',
                paddingLeft: '30px',
                paddingRight: '30px',
              }}
            >
              <span
                style={{
                  fontWeight: '600',
                  fontSize: '14px',
                  color: 'white',
                }}
              >
                {item.label}
              </span>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <button
            disabled={currentPage === 1}
            style={AddToListbuttonStyle}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </button>
          <span style={{ margin: '0 10px', color: 'white' }}>
            {currentPage} / {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            style={AddToListbuttonStyle}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
        <div>
          <h5 style={{ fontWeight: 'bold' }}>Note :</h5>
          <ul>
            <li>
              Don&apos;t delete the &ldquo;Integration Id&ldquo; and
              &ldquo;ServiceNow Table Number&rdquo;
              columns.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const BasicConfiguration = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isCheckedDelete, setIsCheckedDelete] = useState(false);
  const [isCheckedCreate, setIsCheckedCreate] = useState(true);
  const [isCheckedUpdate, setIsCheckedUpdate] = useState(true);
  const [isCheckedComment, setIsCheckedComment] = useState(true);
  const [token, setToken] = useState();
  const [load, setLoad] = useState(false);
  const [loadDropdown, setLoadDropdown] = useState(false);
  const [fetchedTables, setFetchedTables] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [snowSysIds, setSnowSysId] = useState('');
  const [allOptions, setAllOptions] = useState([]);
  const [fieldItemsList, setFieldItemsList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [optionsOfSnow, setSnowOptions] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get('userId');
  const accountId = queryParams.get('accountId');
  const boardId = queryParams.get('boardId');
  const recipeId = queryParams.get('recipeId');

  // 👇 important (parse JSON)
  const accountData = JSON.parse(queryParams.get('accountData') || '[]');

  console.log(userId, accountId, boardId, recipeId, accountData[0],"servicenow config data basic");
  const urlData = accountData[0]?.user_config[0]?.fields_val || '';
  const subdomain =urlData? new URL(urlData).hostname.split('.')[0]:'';
  const decryptedClientSecret = decryptPlainText(accountData[0]?.user_config[2]?.fields_val || '');

  const [formData, setFormData] = useState({
    baseUrl: subdomain|| '',
    clientId: accountData[0]?.user_config[1]?.fields_val||'',
    clientSecret: decryptedClientSecret||'',
    mondayField: '',
    snowAppName: accountData[0]?.user_config[9]?.fields_val||'',
    mondayIntgUserId: accountData[0]?.user_config[10]?.fields_val||'',
  });

  const [formDataOfApiUrls, setFormDataOfApiUrls] = useState('');

  const [snowAPI, setSnowAPI] = useState({
    getUrl:accountData[0]?.process_urls[0]?.get || '',
    createUrl: accountData[0]?.process_urls[0]?.create || '',
    updateUrl: accountData[0]?.process_urls[0]?.update || '',
    getFieldsUrl:accountData[0]?.process_urls[0]?.get_fields || '',
    attachmentUrl:accountData[0]?.process_urls[0]?.attachments || ''
  });

  const [optionsServiceNowTables, setOptionsServiceNowTables] = useState([]);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const pageSize = 10;
  console.log('Search',search);
  // eslint-disable-next-line no-unused-vars
  const handleToggleDelete = () => {
    setIsCheckedDelete(!isCheckedDelete);
  };

  const handleToggleCreate = () => {
    const acoountDataToggleCreate=accountData[0]?.user_config[4]?.fields_val==='yes'?true:false;
    setIsCheckedCreate(acoountDataToggleCreate||!isCheckedCreate);
  };

  const handleToggleUpdate = () => {
    const acoountDataToggleUpdate=accountData[0]?.user_config[5]?.fields_val==='yes'?true:false;
    setIsCheckedUpdate(acoountDataToggleUpdate||!isCheckedUpdate);
  };

  const handleToggleComment = () => {
    const acoountDataToggleComment=accountData[0]?.user_config[6]?.fields_val==='yes'?true:false;
    setIsCheckedComment(acoountDataToggleComment||!isCheckedComment);
  };

  useEffect(()=>{
    const fetchSnowData=async()=>{
      setLoadDropdown(true);
      try{
        if(formData?.baseUrl&&token){
          const data = await fetchTables();
          console.log('Fetched Tables ',data);
          setFetchedTables(data);
          const takeProcessType=accountData[0].process_type||'';
          console.log('Take Process Type ',takeProcessType);
          if(takeProcessType){
            const findProcessType=data.find((item)=>item.value===takeProcessType);
            setFormDataOfApiUrls({value:findProcessType?.value,label:findProcessType?.label});
          }else{
            setFormDataOfApiUrls('');
          }
          
        }else{
          console.log('Base URL or Token is missing');
        }

      }catch(error){
        console.log('Error ',error);
      }finally{
        setLoadDropdown(false);
      }
    }
    fetchSnowData();
  },[formData?.baseUrl,token]);

  // const handleFieldItemsChange = (selectedOption) => {
  //     const selectedItem = selectedOption.value;
  //     let matchField = fieldItemsList.some(item => item.value === selectedItem);
  //     if (!matchField) {
  //         setFieldItemsList([...fieldItemsList, selectedOption]);
  //     } else {
  //         toast.error("Added Already !");
  //     }
  // };

  // const handleFieldRemoveItem = (index) => {
  //     const newList = [...fieldItemsList];
  //     newList.splice(index, 1);
  //     setFieldItemsList(newList);
  // };

  const steps = [
    { title: 'Basic Configuration' },
    { title: 'API URL Information' },
    { title: 'Fields Information' },
  ];
  const handleStepChange = async (step) => {
    if (step === 1) {
      const regex =
        /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,6})(\/[^\s]*)?$/;
      const urlData = regex.test(formData.baseUrl);
      if (urlData) {
        toast.error('Please enter an instance name, not a URL.');
        return; // Prevent form submission
      }
      let resp = await chkValidationBasicConfig(step);
      if (resp === true) {
        if (token === undefined) {
          await openOauth2ServiceNow(step);
        } else {
          setCurrentStep(step);
        }
      } else {
        toast.error('All Fields Are Required!');
        return;
      }
    } else if (parseInt(step) === 2) {
      if (
        formDataOfApiUrls !== '' &&
        snowAPI.getUrl !== '' &&
        snowAPI.createUrl !== '' &&
        snowAPI.updateUrl !== '' &&
        snowAPI.attachmentUrl !== '' &&
        snowAPI.getFieldsUrl !== ''
      ) {
        let access_token = token.access_token;
        let getFields = snowAPI.getFieldsUrl;
        let snow_base_url = `https://${formData.baseUrl}.service-now.com/`;
        let sessionUrl = snow_base_url + getFields;
        let getURL=snow_base_url+snowAPI.getUrl;
        const validate=async()=>{
          try{
            const responseOfValidate = await fetch(`${NODE_APP_BASE_URL}/getValidateTable`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                access_token: access_token,
                getURL: getURL,
              }),
            });
            const convertJson=await responseOfValidate.json();
            if(convertJson?.status==403){
              toast.error(`The ${formDataOfApiUrls?.label} table requires specific security permissions.`);
              setCurrentStep(step-1);
              return;
            }
          }catch(error){
            console.log('Error ',error);
            return;
          }finally{
            setLoad(false);
          }
        };
        validate();
        const fetchData = async () => {
          setLoad(true);
          const res = await fetch(`${NODE_APP_BASE_URL}/getSnowFields`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              access_token: access_token,
              sessionUrl: sessionUrl,
            }),
          });

          try {
            let snowFieldsData = [];
            const json = await res.json();
            setLoad(false);
            json.map((tables_fields) => {
              if(tables_fields.read_only.value=='false'){
                if (
                  tables_fields.column_label.value !== null &&
                  tables_fields.column_label.value !== '' &&
                  tables_fields.column_label.value !== undefined
                ) {
                  if(tables_fields.internal_type.value!='glide_list'&&tables_fields.internal_type.value!='journal_input'&&
                      tables_fields.internal_type.value!='timer'&&tables_fields.internal_type.value!='journal_list'&&tables_fields.internal_type.value!='collection'&&
                      tables_fields.internal_type.value!='GUID'&&tables_fields.internal_type.value!='document_id'&&tables_fields.internal_type.value!='variables'&&tables_fields.internal_type.value!='glide_duration'&&
                      tables_fields.internal_type.value!='journal'&&tables_fields.internal_type.value!='table_name'&&tables_fields.internal_type.value!='sys_class_name'&&tables_fields.internal_type.value!='domain_path'){
                    snowFieldsData.push({
                      value: tables_fields.element.value,
                      label: tables_fields.column_label.value,
                      type:  tables_fields.internal_type.value
                    });
                  }
                }
              }
            });
            // if (formDataOfApiUrls.enable == 'task') {
              // let filteredArrayOfIncident = snowFieldsData.filter(
              //   (item) =>
              //     item.value === 'short_description' ||
              //     item.value === 'description' ||
              //     item.value === 'state' ||
              //     item.value === 'impact' ||
              //     item.value === 'urgency'
              // );
              let uniqueArray = [
                ...new Map(
                  snowFieldsData.map((item) => [item.value, item])
                ).values(),
              ];
              // let updatedArray = uniqueArray.map((item) =>
              //   item.value === 'short_description'
              //     ? { ...item, label: 'Short description' }
              //     : item
              // );
              setFieldItemsList(uniqueArray);
            // }
            // setSnowOptions(snowFieldsData)
          } catch (e) {
            //Error occured while fetching fields
            setLoad(false);
            toast.error(
              'Not able to fecth Snow fields. Check configuraton in form OR ensure servicenow instance is up',
              {
                duration: 10000,
              }
            );
          }
        };
        fetchData();
      } else {
        toast.error('All Fields Are Required!');
        return;
      }
    }
    setCurrentStep(step);
  };

  const openOauth2ServiceNow = async (step) => {
    try {
      // Replace the following URL with your OAuth2 authentication URL
      setLoad(true);
      const baseUrl = `https://${formData.baseUrl}.service-now.com/`;
      const clientId = formData.clientId;
      const redirectUri = `${REACT_APP_BASE_URL}/getOauthToken`;
      const clientSecret = formData.clientSecret;
      const state = '123';

      const oauth2AuthUrl = `${baseUrl}/oauth_auth.do?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&state=${state}`;
      // Open a new window for OAuth2 authentication
      const oauth2Window = window.open(
        oauth2AuthUrl,
        '_blank',
        'width=600,height=400'
      );

      // Handle cases when the new window is closed or blocked by the browser
      if (!oauth2Window) {
        throw new Error('Popup blocked! Please enable popups for this website.');
      }
      // Listen for the message from the OAuth2Login component
      const messageListener = async (event) => {
        if (event.origin === window.origin) {
          // Remove the event listener
          window.removeEventListener('message', messageListener);

          // Handle success information received from the OAuth2Login component
          const successInfo = event.data;
          const postData = {
            code: successInfo,
            client_id: clientId,
            client_secret: clientSecret,
            base_url: baseUrl,
          };

          try {
            const res = await fetch(`${NODE_APP_BASE_URL}/getOauthToken`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(postData),
            });

            const json = await res.json();

            if (json.msg === 'error') {
              toast.error('Something went wrong');
              return false;
            } else {
              const snowGetAppDetailsUrl = `${baseUrl}/api/now/table/oauth_credential?sysparm_query=type%3Drefresh_token%5Epeer.name%3D${formData.snowAppName}&sysparm_limit=1`;
              const accessToken = json.msg.access_token;
              const snowBodyData = {
                snowGetAppDetailsUrl: snowGetAppDetailsUrl,
                accessToken: accessToken,
              };
              try {
                setLoad(true);
                const snowAppDetailsResponse = await fetch(
                  `${NODE_APP_BASE_URL}/getSnowAppData`,
                  {
                    method: 'post',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(snowBodyData),
                  }
                );
                const reponseJson = await snowAppDetailsResponse.json();
                if (reponseJson.result.length !== 0) {
                  const snowSysId = reponseJson.result[0].sys_id;
                  const expiryDateFirst = reponseJson.result[0].expires;
                  setSnowSysId(snowSysId);
                  if (snowSysId) {
                    const updateExpiryBodyData = {
                      snowGetAppDetailsUrl: `${baseUrl}/api/now/table/oauth_credential/${snowSysId}`,
                      accessToken: accessToken,
                      expiryDateFirst: expiryDateFirst,
                    };
                    const updateExpiryDateRefresh = await fetch(
                      `${NODE_APP_BASE_URL}/updateExpiryDateRefresh`,
                      {
                        method: 'post',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(updateExpiryBodyData),
                      }
                    );
                    const responseUpdate = await updateExpiryDateRefresh.json();
                    if (
                      responseUpdate.result.expires !== '' &&
                      responseUpdate.result.token_issued !== ''
                    ) {
                      setLoad(false);
                      const tokenDatas = {
                        access_token: json.msg.access_token,
                        refresh_token: json.msg.refresh_token,
                        scope: json.msg.scope,
                        token_type: json.msg.token_type,
                        expires_in: json.msg.expires_in,
                        refresh_token_expiry_date:
                          responseUpdate.result.expires,
                      };
                      setToken(tokenDatas);
                      toast.success('Authentication Successfull');
                    } else {
                      setLoad(false);
                      toast.error('Authentication Error!');
                    }
                  } else {
                    setLoad(false);
                    toast.error('Authentication Error!');
                  }
                } else {
                  setLoad(false);
                  setCurrentStep(step - 1);
                  toast.error('Invalid credentials please check');
                }
              } catch (err) {
                setLoad(false);
                toast.error('Error occured while authorization');
              }
              // setCurrentStep(step);
              return true;
            }
          } catch (e) {
            setLoad(false);
            // Handle any exceptions
            toast.error('Something went wrong');
            return false;
          } finally {
            setLoad(false);
            // Close the OAuth2 window
            oauth2Window.close();
          }
        }
      };

      // Set a timeout to stop listening after a specified duration
    //   const timeoutId = setTimeout(() => {
    //     // Remove the event listener if the timeout is reached
    //     window.removeEventListener('message', messageListener);

    //     // Close the OAuth2 window
    //     oauth2Window.close();
    //   }, 60000);

      // Add the event listener
      window.addEventListener('message', messageListener);
    } catch (error) {
      toast.error('Something went wrong');
      return false;
    }
  };

  // const handleOnFocus = (e) => {
  //     let access_token = token.access_token;
  //     let getFields = snowAPI.getFieldsUrl;
  //     let snow_base_url = formData.baseUrl;
  //     let sessionUrl = snow_base_url + getFields;
  //     const fetchData = async () => {
  //         setLoad(true);
  //         const res = await fetch("http://localhost:80/getSnowFields", {
  //             method: "POST",
  //             headers: {
  //                 "Content-Type": "application/json",
  //             },
  //             body: JSON.stringify({
  //                 access_token: access_token,
  //                 sessionUrl: sessionUrl,
  //             }),
  //         });

  //         try {
  //             let snowFieldsData = [];
  //             const json = await res.json();
  //             setLoad(false);
  //             json.map((tables_fields) => {
  //                 if (
  //                     tables_fields.column_label.value !== null &&
  //                     tables_fields.column_label.value !== "" &&
  //                     tables_fields.column_label.value !== undefined
  //                 ) {
  //                     snowFieldsData.push({
  //                         value: tables_fields.element.value,
  //                         label: tables_fields.column_label.value,
  //                     });
  //                 }
  //             });
  //             setSnowOptions(snowFieldsData)
  //         } catch (e) {
  //             //Error occured while fetching fields
  //             setLoad(false);
  //             toast.error(
  //                 "Not able to fecth Snow fields. Check configuraton in form OR ensure servicenow instance is up",
  //                 {
  //                     duration: 10000,
  //                 },
  //             );
  //         }
  //     };
  //     fetchData();
  // }

  const chkValidationBasicConfig = async (step) => {
    if (parseInt(step) === 1) {
      if (
        formData.baseUrl !== '' &&
        formData.clientId !== '' &&
        formData.clientSecret !== '' &&
        formData.snowAppName !== ''
      ) {
        return true;
      } else {
        return false;
      }
    }
    // else if (active === 2) {
    //     const arrId = ['snow_base_url', 'client_id', 'client_secret'];

    //     const value = await (async function () {
    //         let chk = 'valid';

    //         for await (const id of arrId) {
    //             if (
    //                 document.getElementById(id).value === null ||
    //                 document.getElementById(id).value === '' ||
    //                 document.getElementById(id).value === undefined
    //             ) {
    //                 chk = 'invalid';
    //                 break;
    //             }
    //         }

    //         if (chk === 'valid') {
    //             return true;
    //         } else if (chk === 'invalid') {
    //             return false;
    //         }
    //     })();
    //     return value;
    // } else if (active === 3) {
    //     const arrId = ['get', 'create', 'update', 'getFields', 'attachments'];

    //     let value = await (async function () {
    //         chk = 'valid';

    //         for await (const id of arrId) {
    //             if (
    //                 document.getElementById(id).value == null ||
    //                 document.getElementById(id).value == '' ||
    //                 document.getElementById(id).value == undefined
    //             ) {
    //                 chk = 'invalid';

    //                 break;
    //             }
    //         }

    //         if (chk === 'valid') {
    //             return true;
    //         } else if (chk === 'invalid') {
    //             return false;
    //         }
    //     })();
    //     return value;
    // }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleScrollDown = async () => {
    const start = page * pageSize;
    const end = start + pageSize;

    const more = allOptions.slice(start, end);

    if (more.length > 0) {
      setOptionsServiceNowTables((prev) => [...prev, ...more]);
      setPage((prev) => prev + 1);
    }
  };

  // 🔹 Handle typing
  const handleInputChange = (inputValue, { action }) => {
    if (action === 'input-change') {
      setSearch(inputValue);

      const filtered = allOptions.filter((o) =>
        o.label.toLowerCase().includes(inputValue.toLowerCase())
      );

      setOptionsServiceNowTables(filtered.slice(0, 10)); // show first 10 of search result
      setPage(1);
    }
  };

  const handleMenuOpen = async () => {
   try{
    setLoad(true);
    if(allOptions.length>0){
      setLoad(false);
      return;
    }
    let data = fetchedTables;
    if (!data || data.length === 0) {
      data = await fetchTables();
    }
    console.log('Data in handle menu open ',data,data.length);
    setAllOptions(data);
    setOptionsServiceNowTables(data.slice(0, pageSize));
    setPage(1);
   }catch(error){
    console.error('Error ',error);
    toast.error('Something went wrong');
    return;
   }finally{
    setLoad(false);
   }
  };


  const fetchTables = async () => {
    try{
      const res = await fetch(
      `${NODE_APP_BASE_URL}/serviceNow/tables`,
        {
          method:'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body:JSON.stringify({
            token:token,
            instanceUrl:formData?.baseUrl
          })
        }
      );
      const data = await res.json();
      const tableDataOptionsSorted=data?.tableData?.results?.filter(item=>item.number_ref!='');
      return tableDataOptionsSorted?.map((t) => ({
        value: t.name,
        label: t.label,
      }));
    }
    catch(error){
      console.error('Error ',error);
      toast.error('Something went wrong');
      return;
    }
  };

  const handleSnowTypeAndUrls = (e) => {
    const { value } = e;
    const getAPIData = APIURLs(value);
    setSnowAPI({
      getUrl: getAPIData.getUrl,
      createUrl: getAPIData.createUrl,
      updateUrl: getAPIData.updateUrl,
      getFieldsUrl: getAPIData.getFieldsUrl,
      attachmentUrl: getAPIData.attachmentUrl,
    });
    // setFormDataOfApiUrls((prevData) => ({
    //   ...prevData,
    //   [label]: value,
    // }));
    setFormDataOfApiUrls(e);
  };

  // function getQueryVariable(variable) {
  //   var query = window.location.search.substring(1);
  //   var vars = query.split('&');

  //   for (var i = 0; i < vars.length; i++) {
  //     var pair = vars[i].split('=');

  //     if (pair[0] == variable) {
  //       return pair[1];
  //     }
  //   }
  //   return false;
  // }

  const handleSubmit = async (e) => {
    try{
    e.preventDefault();

    if (fieldItemsList.length !== 0) {
      // basic configuration data
      var Formdata_modified = [];
      Formdata_modified.push({
        fields_key: 'base_url',
        fields_val: `https://${formData.baseUrl}.service-now.com/`,
      });
      Formdata_modified.push({
        fields_key: 'client_id',
        fields_val: formData.clientId,
      });
      Formdata_modified.push({
        fields_key: 'client_secret',
        fields_val: formData.clientSecret,
      });
      Formdata_modified.push({
        fields_key: 'item_field_id',
        fields_val: 'u_monday_intg_id',
      });
      Formdata_modified.push({
        fields_key: 'create',
        fields_val: isCheckedCreate === true ? 'yes' : 'no',
      });
      Formdata_modified.push({
        fields_key: 'update',
        fields_val: isCheckedUpdate === true ? 'yes' : 'no',
      });
      Formdata_modified.push({
        fields_key: 'comment',
        fields_val: isCheckedComment === true ? 'yes' : 'no',
      });
      Formdata_modified.push({ fields_key: 'AuthType', fields_val: 'Oauth2' });
      Formdata_modified.push({
        fields_key: 'UserLevel',
        fields_val: 'Standard',
      });
      Formdata_modified.push({
        fields_key: 'snowAppName',
        fields_val: formData.snowAppName,
      });
      Formdata_modified.push({
        fields_key: 'mondayIntgUserId',
        fields_val: formData.mondayIntgUserId,
      });
      let user_config = Formdata_modified;
      //serviceNow process URLs data
      let process_urls = [
        {
          get: snowAPI.getUrl,
          create: snowAPI.createUrl,
          update: snowAPI.updateUrl,
          get_fields: snowAPI.getFieldsUrl,
          attachments: snowAPI.attachmentUrl,
        },
      ];
      let selected_fields = fieldItemsList;
      let processType = formDataOfApiUrls.value;          
      setLoad(true);
      const res = await fetch(
        `${NODE_APP_BASE_URL}/StoreUserConfigInformation`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userId: userId.trim(),
            accountId: accountId.trim(),
            boardId: boardId.trim(),
            recipeId: boardId.trim(),
            user_config: user_config,
            process_type: processType,
            process_urls: process_urls,
            selected_fields: selected_fields,
            token: token,
          }),
        }
      );
      const json = await res.json();
      await changeColumnTitle(
        Number(boardId),
        'number_servicenow',
        `${processType}`,
      );
      setLoad(false);
      if (res.status) {
        if (json.msg == 'successful') {
          toast.success('Data Saved Successfully');
          // window.location = getQueryVariable('backToUrl');
        } else {
          toast.error('Account Exists');
        }
      } else {
        toast.error('Something went wrong..');
      }
    } else {
      toast.error(
        `Please choose the serviceNow ${formDataOfApiUrls?.value} Fields`
      );
    }
  }catch(error){
    console.error('Error while stroring the data ',error);
    toast.error('Something went wrong');
    return;
  }finally{
    setLoad(false); 
  }
  };

  return (
    <>
      <Toaster />
      <span>
        {' '}
        {load == true ? (
          <MyComponent height="100%" width="100%" sentences={['Loading....']} />
        ) : (
          ''
        )}{' '}
      </span>
      <Container fluid>
        <Row
          className="justify-content-center align-items-center"
          style={{ height: '85vh' }}
        >
          <Col
            xs={12}
            md={8}
            lg={6}
            xl={6}
            className="justify-content-center align-items-center"
          >
            <Card
              style={{
                backgroundColor: '#188754',
                color: '#A5E2C6',
                border: 'none',
              }}
            >
              <Card.Body>
                <div>
                  <Stepper
                    steps={steps}
                    activeStep={currentStep}
                    activeColor="#007bff"
                    completeColor="#28a745"
                    size={40}
                    circleFontSize={15}
                    titleFontSize={10}
                    activeTitleColor="#ffffff"
                    completeTitleColor="#95D9BB"
                    defaultTitleColor="#95D9BB"
                    defaultBorderStyle="#FFF666"
                    activeBorderStyle="#FFFFF5"
                    defaultBorderWidth={8}
                    defaultBorderColor="#FFF666"
                  />
                  <br />
                  {currentStep === 0 && (
                    <Step1Component
                      formData={formData}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      isCheckedCreate={isCheckedCreate}
                      isCheckedUpdate={isCheckedUpdate}
                      isCheckedComment={isCheckedComment}
                      handleToggleCreate={handleToggleCreate}
                      handleToggleUpdate={handleToggleUpdate}
                      handleToggleComment={handleToggleComment}
                    />
                  )}
                  {currentStep === 1 && (
                    <Step2Component
                      formDataOfApiUrls={formDataOfApiUrls}
                      handleSnowTypeAndUrls={handleSnowTypeAndUrls}
                      snowAPI={snowAPI}
                      // loadOptions={loadOptions}
                      optionsServiceNowTables={optionsServiceNowTables}
                      handleMenuOpen={handleMenuOpen}
                      selectedValue={formDataOfApiUrls}
                      handleInputChange={handleInputChange}
                      handleScrollDown={handleScrollDown}
                      // handleScrollUp={handleScrollUp}
                      loadDropdown={loadDropdown}
                    />
                  )}
                  {currentStep === 2 && (
                    <Step3Component
                      options={optionsOfSnow}
                      fieldItemsList={fieldItemsList}
                      optionsServiceNowTables={allOptions}
                    />
                  )}
                </div>
                <div style={{ marginLeft: '3%' }}>
                  {currentStep === 0 ? (
                    <></>
                  ) : (
                    <>
                      <button
                        onClick={() => handleStepChange(currentStep - 1)}
                        disabled={currentStep === 0}
                        style={PrevbuttonStyle}
                      >
                        Previous
                      </button>
                    </>
                  )}{' '}
                  &nbsp;
                  {/* <button onClick={() => handleStepChange(currentStep + 1)} disabled={currentStep === steps.length - 1} style={NextbuttonStyle}>Next</button> */}
                  {currentStep === steps.length - 1 ? (
                    <button onClick={handleSubmit} style={AddToListbuttonStyle}>
                      Submit
                    </button>
                  ) : (
                    <button
                      onClick={() => handleStepChange(currentStep + 1)}
                      disabled={currentStep === steps.length - 1}
                      style={NextbuttonStyle}
                    >
                      Next
                    </button>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={3} style={{ marginLeft: '8%' }}>
            <Image
              src="\images\serviceNowLogoNew.png"
              alt="GIF"
              height={100}
              width={150}
              fluid
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BasicConfiguration;
